import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fbeb14b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 提示 ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "系统检测到当前提交日志与提单所在位置距离较远，可能会影响后续维修的服务权益判定。确认仍按当前日志提单？")
], -1))
const _hoisted_3 = { class: "btn-wrap" }

import {Dialog} from 'vant'
import {ref} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'on-site-bill-lading-tip-dialog',
  emits: ['goBack', 'continue'],
  setup(__props, { expose, emit: emits }) {




expose({
  setShow(value: boolean) {
  show.value = value
}
})

const show = ref(false)



function clickHandle (type: string) {
  if(type === 'goBack') {
    show.value = false
    emits('goBack')
  }else {
    show.value = false
    emits('continue')
  }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog).Component, {
    show: show.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    "get-container": "body"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "cancel-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandle('goBack')))
        }, "返回修改"),
        _createElementVNode("div", {
          class: "confirm-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandle('continue')))
        }, "确认")
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})